import { render } from "./AddUserReportLocation.vue?vue&type=template&id=a5b65962"
import script from "./AddUserReportLocation.vue?vue&type=script&lang=js"
export * from "./AddUserReportLocation.vue?vue&type=script&lang=js"

import "./AddUserReportLocation.vue?vue&type=style&index=0&id=a5b65962&lang=less"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__